


import React, { useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Button from '@mui/material/Button';
import styles from './TimePeriodSelector.module.css'; 

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// Months of 2025
const months2025 = [
  'January 2025', 'February 2025', 'March 2025', 'April 2025',
  'May 2025', 'June 2025', 'July 2025', 'August 2025',
  'September 2025', 'October 2025', 'November 2025', 'December 2025'
];

export default function TimePeriodSelector({ onSelect }) {
  const [selected, setSelected] = useState([]);

  return (
    <div className={styles.timePeriodSelector}>
      <Autocomplete
        multiple
       
        disableCloseOnSelect
        options={months2025}
        value={selected}
        onChange={(event, value) => setSelected(value)}
        getOptionLabel={option => option}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option}
          </li>
        )}
        style={{ width: "100%", background: '#fff', borderRadius: 6 }}
        ListboxProps={{
          style: {
            maxHeight: 250,
            overflowY: 'auto',
            border: '1px solid #e3e8ef',
            borderRadius: 5,
            background: '#fff',
            padding: '6px 7px',
            marginBottom: 11,
          }
        }}
        
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select Month(s) in 2025"
            placeholder="Type to search…"
            className={styles.calendarInput}
            
          />
        )}
      />
      <Button
        variant="contained"
        className={styles.confirmBtn}
        disabled={selected.length === 0}
        onClick={() => onSelect(selected)}
      >
        Confirm Selection
      </Button>
    </div>
  );
}
